// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ReleaseChannel,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  appChannelKey: __t.string().name("app_channel_key"),
  appId: __t.string().name("app_id"),
  get channel() {
    return ReleaseChannel;
  },
  launchArgs: __t.option(__t.string()).name("launch_args"),
  displayName: __t.option(__t.string()).name("display_name"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedBy: __t.identity().name("updated_by"),
  autoUpdate: __t.bool().name("auto_update"),
});
